import { LABELS } from '@/constants/common/message.constants'

import { type ContractEntity } from '../..'

/**
 * 配送先地点種別
 */
export type ResolveMethodType = NonNullable<ContractEntity['resolveMethod']>

export const RESOLVE_METHOD_TYPE = {
  /** 全てを含む */
  EVERY: 'EVERY',
  /** いずれかを含む */
  SOME: 'SOME'
} as const satisfies Record<ResolveMethodType, ResolveMethodType>

export const RESOLVE_METHOD_TYPE_LABEL = {
  [RESOLVE_METHOD_TYPE.EVERY]: LABELS.DESTINATION_SITE_TYPE_EVERY,
  [RESOLVE_METHOD_TYPE.SOME]: LABELS.DESTINATION_SITE_TYPE_SOME
} as const satisfies Record<ResolveMethodType, string>
